import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllProducts = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Product.GetAllProducts}?${query}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const GetProductById = async (productId) => {
    try {
        const response = await api.get(`${endpoints.Product.GetProductById}?id=${productId}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const AddProduct = async (formData) => {
    try {
        const response = await api.post(
            endpoints.Product.AddProduct,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error("Error adding product:", error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: "Error adding product",
        };
    }
};

export const UpdateProduct = async (productId,formData) => {
    try {
        const response = await api.put(
            `${endpoints.Product.UpdateProduct}?id=${productId}`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error("Error updating product:", error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: "Error updating product",
        };
    }
};

export const DeleteProduct = async (productId) => {
    try {
        const response = await api.delete(`${endpoints.Product.DeleteProduct}?id=${productId}`);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const GetProductAndCategoryCounts = async (params) => {
    try {
        const query = params ? new URLSearchParams(params).toString() : "";
        const response = await api.get(`${endpoints.Product.GetProductAndCategoryCounts}${query ? `?${query}` : ""}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

const ProductService = {
    GetAllProducts,
    DeleteProduct,
    UpdateProduct
};

export default ProductService;